"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetcherClient = void 0;
const fetcher_error_1 = require("./fetcher-error");
const util_1 = require("./util");
const DEFAULT_AUTH_PROFILE_HANDLER = () => ({ shouldRetry: false });
class FetcherClient {
    constructor(config) {
        var _a, _b, _c, _d;
        this.axios = (_a = config.axiosFetcher) !== null && _a !== void 0 ? _a : (0, util_1.getDefaultAxiosFetcher)();
        this.baseUrl = config.baseUrl;
        this.baseHeaders = (_b = config.baseHeaders) !== null && _b !== void 0 ? _b : {};
        this.authProfileHandler = (_c = config.authProfileHandler) !== null && _c !== void 0 ? _c : DEFAULT_AUTH_PROFILE_HANDLER;
        this.maxAuthRetry = (_d = config.maxAuthRetry) !== null && _d !== void 0 ? _d : 1;
        this.logger = config.logger;
    }
    async get({ url, queryParams, headers, responseType, validator, disableStrictSsl, }) {
        const response = await this.getManual({ url, queryParams, headers, responseType, disableStrictSsl });
        if (!(0, util_1.isSuccessResponse)(response)) {
            const fullUrl = (0, util_1.getUrl)({ baseURL: this.baseUrl, url });
            const fullUrlWithParams = (0, util_1.getUrlWithQuery)({ baseURL: this.baseUrl, url, params: queryParams });
            this.logger.error(`GET response to ${fullUrl} was unsuccessful`, { response, fullUrlWithParams });
            throw new fetcher_error_1.FetcherError(`Unable to GET ${fullUrl}`, response);
        }
        if (validator) {
            const { data } = await (0, util_1.handleResponseValidation)(response, validator, url);
            return data;
        }
        return response.data;
    }
    async getManual({ url, queryParams, headers, responseType, disableStrictSsl, }) {
        return (0, util_1.fetchData)(this.axios, {
            method: 'GET',
            baseURL: this.baseUrl,
            headers: { ...this.baseHeaders, ...headers },
            url,
            params: queryParams,
            responseType,
            validateStatus: util_1.axiosStatusValidator,
            httpsAgent: (0, util_1.getHttpsAgent)(disableStrictSsl),
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
        }, this.authProfileHandler, this.maxAuthRetry, this.logger);
    }
    async post({ url, queryParams, body, headers, responseType, validator, disableStrictSsl, }) {
        const response = await this.postManual({ url, queryParams, body, headers, responseType, disableStrictSsl });
        if (!(0, util_1.isSuccessResponse)(response)) {
            const fullUrl = (0, util_1.getUrl)({ baseURL: this.baseUrl, url });
            const fullUrlWithParams = (0, util_1.getUrlWithQuery)({ baseURL: this.baseUrl, url, params: queryParams });
            this.logger.error(`POST response to ${fullUrl} was unsuccessful`, { response, fullUrlWithParams });
            throw new fetcher_error_1.FetcherError(`Unable to POST ${fullUrl}`, response);
        }
        if (validator) {
            const { data } = await (0, util_1.handleResponseValidation)(response, validator, url);
            return data;
        }
        return response.data;
    }
    async postManual({ url, queryParams, body, headers, responseType, disableStrictSsl, }) {
        return (0, util_1.fetchData)(this.axios, {
            method: 'POST',
            baseURL: this.baseUrl,
            headers: { ...this.baseHeaders, ...headers },
            url,
            params: queryParams,
            data: body,
            responseType,
            validateStatus: util_1.axiosStatusValidator,
            httpsAgent: (0, util_1.getHttpsAgent)(disableStrictSsl),
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
        }, this.authProfileHandler, this.maxAuthRetry, this.logger);
    }
    async put({ url, queryParams, body, headers, responseType, validator, disableStrictSsl, }) {
        const response = await this.putManual({ url, queryParams, body, headers, responseType, disableStrictSsl });
        if (!(0, util_1.isSuccessResponse)(response)) {
            const fullUrl = (0, util_1.getUrl)({ baseURL: this.baseUrl, url });
            const fullUrlWithParams = (0, util_1.getUrlWithQuery)({ baseURL: this.baseUrl, url, params: queryParams });
            this.logger.error(`PUT response to ${fullUrl} was unsuccessful`, { response, fullUrlWithParams });
            throw new fetcher_error_1.FetcherError(`Unable to PUT ${fullUrl}`, response);
        }
        if (validator) {
            const { data } = await (0, util_1.handleResponseValidation)(response, validator, url);
            return data;
        }
        return response.data;
    }
    async putManual({ url, queryParams, body, headers, responseType, disableStrictSsl, }) {
        return (0, util_1.fetchData)(this.axios, {
            method: 'PUT',
            baseURL: this.baseUrl,
            headers: { ...this.baseHeaders, ...headers },
            url,
            params: queryParams,
            data: body,
            responseType,
            validateStatus: util_1.axiosStatusValidator,
            httpsAgent: (0, util_1.getHttpsAgent)(disableStrictSsl),
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
        }, this.authProfileHandler, this.maxAuthRetry, this.logger);
    }
    async delete({ url, queryParams, body, headers, responseType, validator, disableStrictSsl, }) {
        const response = await this.deleteManual({ url, queryParams, body, headers, responseType, disableStrictSsl });
        if (!(0, util_1.isSuccessResponse)(response)) {
            const fullUrl = (0, util_1.getUrl)({ baseURL: this.baseUrl, url });
            const fullUrlWithParams = (0, util_1.getUrlWithQuery)({ baseURL: this.baseUrl, url, params: queryParams });
            this.logger.error(`DELETE response to ${fullUrl} was unsuccessful`, { response, fullUrlWithParams });
            throw new fetcher_error_1.FetcherError(`Unable to DELETE ${fullUrl}`, response);
        }
        if (validator) {
            const { data } = await (0, util_1.handleResponseValidation)(response, validator, url);
            return data;
        }
        return response.data;
    }
    async deleteManual({ url, queryParams, body, headers, responseType, disableStrictSsl, }) {
        return (0, util_1.fetchData)(this.axios, {
            method: 'DELETE',
            baseURL: this.baseUrl,
            headers: { ...this.baseHeaders, ...headers },
            url,
            params: queryParams,
            data: body,
            responseType,
            validateStatus: util_1.axiosStatusValidator,
            httpsAgent: (0, util_1.getHttpsAgent)(disableStrictSsl),
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
        }, this.authProfileHandler, this.maxAuthRetry, this.logger);
    }
}
exports.FetcherClient = FetcherClient;
//# sourceMappingURL=client.js.map